import { logger } from './logger';

/**
 * AWS Amplify (Cognito) の設定。共有モジュール（frontend/shared/auth）。
 * 各アプリの lib/amplify-config.ts はここを再エクスポートする。
 * Cognito モード時のみ Amplify を動的 import して設定する。
 */
export const configureAmplify = async () => {
  if (process.env.NEXT_PUBLIC_AUTH_MODE === 'cognito') {
    try {
      const { Amplify } = await import('aws-amplify');

      Amplify.configure({
        Auth: {
          Cognito: {
            userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID || '',
            userPoolClientId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID || '',
          }
        }
      }, { ssr: true });

      logger.info('Amplifyライブラリの設定を完了しました');
    } catch (error) {
      logger.error('Cognito用のAmplify設定中にエラーが発生しました', error);
    }
  } else {
    logger.info('ローカル認証モードのため、Amplify設定はスキップされました。');
  }
};
